import { render } from "./shoppingCart .vue?vue&type=template&id=64e66d5b&scoped=true"
import script from "./shoppingCart .vue?vue&type=script&lang=js"
export * from "./shoppingCart .vue?vue&type=script&lang=js"

import "./shoppingCart .vue?vue&type=style&index=0&id=64e66d5b&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64e66d5b"]])

export default __exports__